'use client';

import { useEffect } from 'react';
import { GOOGLE_INCLUDED_LANGUAGES, PAGE_LANGUAGE } from '@/lib/googleTranslate';

const SCRIPT_ID = 'google-translate-script';

export default function GoogleTranslateWidget() {
  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) return;

    window.googleTranslateElementInit = () => {
      if (!window.google?.translate?.TranslateElement) return;
      new window.google.translate.TranslateElement(
        {
          pageLanguage: PAGE_LANGUAGE,
          includedLanguages: GOOGLE_INCLUDED_LANGUAGES,
          autoDisplay: false,
          layout: 0,
        },
        'google_translate_element'
      );
    };

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src =
      'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return <div id="google_translate_element" className="google-translate-host" aria-hidden="true" />;
}
